import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="hero" className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-20" data-id="element-43">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        filter: 'blur(10px)'
      }} animate={{
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)'
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-12" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/1Wt6xZ2CEnACLmcpPMDgdq/pasted-image.jpg" alt="AVM Logo" className="h-24 md:h-32 object-contain logo-blend opacity-90 mx-auto" data-id="element-46" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="font-serif text-5xl md:text-7xl lg:text-8xl text-avm-text mb-8 tracking-tight leading-none" data-id="element-47">
          Atlas Ventures Management LLC
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center" data-id="element-48">
          <p className="font-sans text-lg md:text-xl text-avm-textMuted max-w-2xl font-light leading-relaxed mb-10" data-id="element-49">
            Building and operating technology-first businesses within
            traditional industries.
          </p>
          <div className="w-16 h-[1px] bg-avm-accent/60" data-id="element-50"></div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.2
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4" data-id="element-51">
        <span className="text-xs uppercase tracking-[0.2em] text-avm-textMuted/50" data-id="element-52">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-avm-textMuted/50 to-transparent" data-id="element-53"></div>
      </motion.div>
    </section>;
}